import cls from "classnames";
import Link from "next/link";

import { QOOHOO_WEBSITE_DOMAIN } from "constants/env";
import QoohooIcon from "./icons/QoohooIcon";

export default function Footer({ className }) {
    return (
      <div className={cls("w-full flex flex-col sm:flex-row items-center gap-4 pb-6 sm:pb-3 md:pb-0 sm:gap-0 justify-center sm:justify-between", className)}>
        <Link
          className="flex flex-row items-center justify-center"
          href={QOOHOO_WEBSITE_DOMAIN}
        >
          <span className="text-sm mr-1.5  text-[#16191B] whitespace-nowrap">
            Powered by
          </span>
          <QoohooIcon className="w-auto select-none h-4 text-[#16191B] " />
        </Link>
        <div className="flex gap-[1.125rem] items-center text-sm text-[#6A7175]">
          <Link
            href={`${QOOHOO_WEBSITE_DOMAIN}/pages/privacy`}
          >
            Privacy Policy
          </Link>
          <div className="h-3 w-[1px] bg-[#6A717559]"></div>
          <Link
            href={`${QOOHOO_WEBSITE_DOMAIN}/stdeula`}
          >
            Terms
          </Link>
        </div>
      </div>
    );
  }
  